import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";

export default function InfluencerRegistrationForm() {
  return (
    <div className="Influencer-Registration-Form bg-[#F5F5F5] pt-[160px] sm:pt-0">
      <Helmet>
        <title>Influencer Registration Form - Mean3 Software Solutions</title>
      </Helmet>
      <Section1 />
      <Section2 />
    </div>
  );
}
